import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';

import { filedGetFieldAPI } from '@/api/crm/common';
import { crmContractSaveAPI } from '@/api/crm/contract';
import { crmBusinessProductAPI } from '@/api/crm/business';

import XrCreate from '@/components/XrCreate';
import CreateSections from '@/components/CreateSections';
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems';
import { XhProduct, CrmRelativeCell } from '@/components/CreateCom';
import CreateExamineInfo from '@/components/Examine/CreateExamineInfo';

import CustomFieldsMixin from '@/mixins/CustomFields';
import { debounce } from 'throttle-debounce';
import { objDeepCopy } from '@/utils';
// import { isEmpty } from '@/utils/types'

export default {
  // 新建编辑
  name: 'ContractCreate',

  components: {
    XrCreate: XrCreate,
    CreateSections: CreateSections,
    CrmRelativeCell: CrmRelativeCell,
    XhProduct: XhProduct,
    CreateExamineInfo: CreateExamineInfo,
    WkFormItems: WkFormItems
  },

  mixins: [CustomFieldsMixin],

  props: {
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save',
          id: '',
          data: {}
        };
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},

      // 审批信息
      examineInfo: {}
    };
  },


  computed: {
    title: function title() {
      if (this.action.title) {
        return this.action.title;
      }
      return this.action.type === 'update' ? '编辑合同' : '新建合同';
    },


    // 合同 回款 下展示审批人信息
    isOpenExamine: function isOpenExamine() {
      if (this.examineInfo) {
        // 初始状态是空对象默认展示，请求之后，根据status判断
        return _Object$keys(this.examineInfo).length > 0 ? this.examineInfo.examineStatus : true;
      }
      return false;
    },


    // 确认名称
    sureBtnTitle: function sureBtnTitle() {
      if (this.isOpenExamine) {
        return '提交审核';
      }
      return '保存';
    }
  },

  watch: {},

  created: function created() {
    this.debouncedSaveField = debounce(300, this.saveClick);

    this.getField();
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 获取数据
     */
    getField: function getField() {
      var _this = this;

      this.loading = true;
      var params = {
        types: 'crm_contract',
        module: 'crm',
        controller: 'contract',
        action: this.action.type,
        format: 2
      };
      if (this.action.type == 'update') {
        params.action_id = this.action.id;
      }

      filedGetFieldAPI(params).then(function (res) {
        var list = res.data || [];
        var assistIds = _this.getFormAssistIds(list);

        var baseFields = [];
        var fieldList = [];
        var fieldRules = {};
        var fieldForm = {};
        list.forEach(function (children) {
          var fields = [];
          children.forEach(function (item) {
            var temp = _this.getFormItemDefaultProperty(item);
            temp.show = !assistIds.includes(item.formAssistId);

            var canEdit = _this.getItemIsCanEdit(item, _this.action.type);
            // 是否能编辑权限
            if (canEdit) {
              // 自动生成编号
              if (item.autoGeneNumber == 1) {
                temp.placeholder = '根据编号规则自动生成，支持手动输入';
                var copyItem = objDeepCopy(item);
                copyItem.isNull = 0;
                fieldRules[temp.field] = _this.getRules(copyItem);
              } else {
                fieldRules[temp.field] = _this.getRules(item);
              }
            }

            // 是否可编辑
            temp.disabled = !canEdit;

            // 禁止某些业务组件选择
            if (temp.form_type == 'contacts' || temp.form_type == 'customer' || temp.form_type == 'business') {
              if (_this.action.type == 'relative') {
                var relativeDisInfos = {
                  contacts: { customer: true },
                  customer: { customer: true },
                  business: { customer: true, business: true }

                  // 在哪个类型下添加
                };var relativeTypeDisInfos = relativeDisInfos[_this.action.crmType];
                if (relativeTypeDisInfos) {
                  // 包含的字段值
                  temp.disabled = relativeTypeDisInfos[item.form_type] || false;
                }
              } else if (_this.action.type != 'update') {
                temp.disabled = item.form_type === 'business' || item.form_type === 'contacts';
              }
            }

            // 处理关联
            if ((_this.action.type == 'relative' || _this.action.type == 'update') && (item.form_type == 'business' || item.form_type == 'contacts' || item.form_type == 'contract')) {
              var customerItem = _this.getItemRelatveInfo(list, 'customer');
              if (customerItem) {
                if (item.form_type == 'business' || item.form_type == 'contacts') {
                  customerItem['moduleType'] = 'customer';
                  temp['relation'] = customerItem;
                } else if (item.form_type == 'contract') {
                  customerItem['moduleType'] = 'customer';
                  customerItem['params'] = { checkStatus: 2 };
                  temp['relation'] = customerItem;
                }
              }
            }
            // 特殊字段允许多选
            _this.getItemRadio(item, temp);

            // 获取默认值
            // 非编辑情况下 填充默认值
            if (_this.action.type != 'update' && item.field === 'order_date') {
              fieldForm[temp.field] = _this.$moment().format('YYYY-MM-DD');
            } else {
              fieldForm[temp.field] = _this.getItemValue(item, _this.action.data, _this.action.type);
            }
            fields.push(temp);
            baseFields.push(item);
          });
          fieldList.push(fields);
        });

        // 填充商机关联的产品信息
        if (_this.action.type == 'relative') {
          var businessData = _this.action.data.business;
          if (businessData) {
            _this.getBusinessProduct(businessData.business_id).then(function (resData) {
              var businessData = resData || {};
              fieldForm.product = {
                product: businessData.list,
                total_price: businessData.total_price,
                discount_rate: businessData.discount_rate
              };
              fieldForm.money = businessData.total_price || '';
            }).catch(function () {});
          }
        }

        _this.baseFields = baseFields;
        _this.fieldList = fieldList;
        _this.fieldForm = fieldForm;
        _this.fieldRules = fieldRules;

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 保存
     */
    saveClick: function saveClick() {
      var _this2 = this;

      var isDraft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loading = true;
      var crmForm = this.$refs.crmForm;
      crmForm.validate(function (valid) {
        if (valid) {
          if (_this2.isOpenExamine) {
            /** 验证审批数据 */
            if (isDraft) {
              // 不验证数据 验证审批人
              _this2.$refs.examineInfo.validateField(function (result) {
                if (result) {
                  var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
                  if (_this2.examineInfo.config === 0 && _this2.examineInfo.hasOwnProperty('value') && _this2.examineInfo.value.length) {
                    params['check_user_id'] = _this2.examineInfo.value[0].id;
                  }
                  params['examineStatus'] = _this2.examineInfo.examineStatus;
                  params.is_draft = 1;
                  _this2.submiteParams(params);
                } else {
                  _this2.loading = false;
                }
              });
            } else {
              _this2.$refs.examineInfo.validateField(function (result) {
                if (result) {
                  var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
                  if (_this2.examineInfo.config === 0) {
                    params['check_user_id'] = _this2.examineInfo.value[0].id;
                  }
                  params['examineStatus'] = _this2.examineInfo.examineStatus;
                  _this2.submiteParams(params);
                } else {
                  _this2.loading = false;
                }
              });
            }
          } else {
            var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
            if (isDraft) {
              params.is_draft = 1;
            }
            _this2.submiteParams(params);
          }
        } else {
          _this2.loading = false;
          // 提示第一个error
          _this2.getFormErrorMessage(crmForm);
          return false;
        }
      });
    },


    /**
     * 提交上传
     */
    submiteParams: function submiteParams(params) {
      var _this3 = this;

      if (this.action.type == 'update' && !this.action.isCopy) {
        params.id = this.action.id;
        params.batchId = this.action.batchId;
      }

      // 相关添加时候的多余提交信息
      if (this.action.relativeData && _Object$keys(this.action.relativeData).length) {
        params = _extends({}, params, this.action.relativeData);
      }

      crmContractSaveAPI(params).then(function (res) {
        _this3.loading = false;
        if (_this3.action.isCopy) {
          _this3.$message.success('操作成功');
        } else {
          _this3.$message.success(_this3.action.type == 'update' ? '编辑成功' : '添加成功');
        }

        _this3.close();

        // 保存成功
        _this3.$emit('save-success', {
          type: 'contract'
        });
      }).catch(function () {
        _this3.loading = false;
      });
    },


    /**
     * 验证唯一
     */
    UniquePromise: function UniquePromise(_ref) {
      var field = _ref.field,
          value = _ref.value;

      return this.getUniquePromise(field, value, this.action);
    },


    /**
     * change
     */
    formChange: function formChange(field, index, value, valueList) {
      // 审批流逻辑
      // this.debouncedGetWkFlowList(field.field, this.fieldForm)

      if (['select', 'checkbox'].includes(field.form_type) && field.remark === 'options_type' && field.optionsData) {
        var _getFormContentByOpti = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm),
            fieldForm = _getFormContentByOpti.fieldForm,
            fieldRules = _getFormContentByOpti.fieldRules;

        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },


    /**
     * 地址change
     */
    otherChange: function otherChange(data, field) {
      var _this4 = this;

      if (field.form_type === 'customer') {
        var contractForCount = 0;
        for (var mainIndex = 0; mainIndex < this.fieldList.length; mainIndex++) {
          var children = this.fieldList[mainIndex];
          for (var index = 0; index < children.length; index++) {
            var element = children[index];
            // 需要处理 需关联客户信息或客户下信息
            var handleFields = ['business_id', 'contacts_id', 'order_user_id'];

            // 添加请求关联
            var addRelation = ['business_id', 'contacts_id'];

            // 需要disabled
            var addDisabled = ['business_id', 'contacts_id'];

            // 复制
            var getValueObj = {
              contacts_id: function contacts_id(data) {
                if (!data.contacts_id) {
                  return [];
                }
                return [{
                  name: data.contactsName || '',
                  contacts_id: data.contacts_id
                }];
              },
              order_user_id: function order_user_id(data) {
                if (!data.ownerUserId) {
                  return [];
                }
                return [{
                  realname: data.owner_user_name || '',
                  id: data.owner_user_id
                }];
              }
            };

            if (handleFields.includes(element.field)) {
              if (data.value.length > 0) {
                element.disabled = false;

                // 增加关联信息
                var customerItem = data.value[0];
                if (addRelation.includes(element.field)) {
                  customerItem['moduleType'] = 'customer';
                  element['relation'] = customerItem;
                }

                // 填充值
                if (getValueObj[element.field]) {
                  this.fieldForm[element.field] = getValueObj[element.field](customerItem);
                } else {
                  this.fieldForm[element.field] = [];
                }
              } else {
                // 禁用
                element.disabled = !!addDisabled.includes(element.field);

                if (addRelation.includes(element.field)) {
                  element['relation'] = {};
                }

                this.fieldForm[element.field] = [];
              }

              contractForCount++;
              if (contractForCount == handleFields.length) {
                break;
              }
            }
          }
        }

        // 重置产品信息
        this.fieldForm.product = {
          product: [],
          total_price: '',
          discount_rate: ''
        };
        this.fieldForm.money = '';
      } else if (field.form_type === 'business') {
        if (data.value.length > 0) {
          this.getBusinessProduct(data.value[0].business_id).then(function (resData) {
            var businessData = resData || {};
            _this4.fieldForm.product = {
              product: businessData.list,
              total_price: businessData.total_price,
              discount_rate: businessData.discount_rate
            };
            _this4.fieldForm.money = businessData.total_price || '';
          }).catch(function () {});
        }
      } else if (field.form_type === 'product') {
        this.fieldForm.money = data.value.total_price || '';
      }
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    },


    /**
     * 获取商机的产品信息进行填充
     */
    getBusinessProduct: function getBusinessProduct(business_id) {
      return new _Promise(function (resolve, reject) {
        crmBusinessProductAPI({
          business_id: business_id,
          pageType: 0
        }).then(function (res) {
          resolve(res.data);
        }).catch(function (err) {
          reject(err);
        });
      });
    },


    /**
     * 审批信息值更新
     */
    examineValueChange: function examineValueChange(data) {
      this.examineInfo = data;
    },


    /**
     * 关闭
     */
    close: function close() {
      this.$emit('close');
    }
  }
};